import { useEffect } from 'react';
import { useIsMobile } from '../utils/useIsMobile';

// =============================================================================
// 모바일 표 → 카드(2026-09-23). 표마다 마크업을 고치지 않고, 모바일 폭일 때 화면의 모든 표에
// data-mobile-cards 를 달고 각 칸에 그 열의 머리 글자를 data-label 로 붙인다. 모양은 globals.css.
// 새로 그려지는 표(목록 새로고침·탭 전환)도 MutationObserver 로 따라간다. 속성만 바꾸고 DOM 구조는
// 건드리지 않으므로 React 렌더와 충돌하지 않는다. 표로 둘 곳은 data-mobile-table="keep".
// =============================================================================

/** 머리 칸의 정렬 화살표·도움말 기호를 걷은 글자. */
export function headerLabel(cell: Element): string {
  return (cell.textContent ?? '').replace(/[▲▼↕ⓘ⇅]/g, '').replace(/\s+/g, ' ').trim();
}

export function labelTable(table: HTMLTableElement): void {
  if (table.dataset.mobileTable === 'keep') return;
  if (!table.hasAttribute('data-mobile-cards')) table.setAttribute('data-mobile-cards', '');
  const head = table.tHead?.rows[table.tHead.rows.length - 1];
  if (!head) return;
  const labels: string[] = [];
  for (const cell of Array.from(head.cells)) {
    const text = headerLabel(cell);
    for (let i = 0; i < Math.max(1, cell.colSpan); i++) labels.push(text);
  }
  for (const body of Array.from(table.tBodies)) {
    for (const row of Array.from(body.rows)) {
      let column = 0;
      for (const cell of Array.from(row.cells)) {
        const label = cell.colSpan === 1 ? labels[column] : '';
        if (label) { if (cell.getAttribute('data-label') !== label) cell.setAttribute('data-label', label); }
        else if (cell.hasAttribute('data-label')) cell.removeAttribute('data-label');
        column += Math.max(1, cell.colSpan);
      }
    }
  }
}

export function MobileTableCards(): null {
  const mobile = useIsMobile();
  useEffect(() => {
    if (!mobile) return;
    let frame = 0;
    const run = () => { frame = 0; document.querySelectorAll('table').forEach(labelTable); };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(run); };
    run();
    // 속성 변경은 보지 않는다 — 우리가 단 data-label 이 다시 불러내지 않게.
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => { observer.disconnect(); if (frame) cancelAnimationFrame(frame); };
  }, [mobile]);
  return null;
}
